/* FCY - Saldi countdown (Mucc 3).

   Regola: le date arrivano dal Liquid come epoch (secondi). E' il BROWSER a decidere
   se mostrare o nascondere, mai Liquid con 'now': le pagine sono in cache CDN e l'ora
   del server nell'HTML puo' essere vecchia.

   Note tecniche (verificate dal vivo il 17/08/2026):
   1. NIENTE MutationObserver. Una prima versione lo usava per reagire all'app BSS che
      riscrive .price, ma l'observer si riattivava a ogni aggiornamento del timer e
      bloccava la pagina. Il nostro blocco vive comunque fuori da .price.
   2. Chrome rallenta i timer nelle schede in secondo piano (fino a 1 volta al minuto).
      Il conto alla rovescia puo' quindi restare fermo mentre la scheda non e' visibile.
      Per questo ricalcoliamo subito al rientro: visibilitychange, focus, pageshow. */
(function () {
  if (window.__fcySaleInit) return;
  window.__fcySaleInit = true;

  var SEL = '[data-fcy-sale]';

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function format(seconds, el) {
    var d = Math.floor(seconds / 86400);
    var h = Math.floor((seconds % 86400) / 3600);
    var m = Math.floor((seconds % 3600) / 60);
    var s = Math.floor(seconds % 60);
    var Ld = el.getAttribute('data-l-d') || 'g';
    var Lh = el.getAttribute('data-l-h') || 'h';
    var Lm = el.getAttribute('data-l-m') || 'm';
    var Ls = el.getAttribute('data-l-s') || 's';
    if (d > 0) return d + Ld + ' ' + pad(h) + Lh + ' ' + pad(m) + Lm + ' ' + pad(s) + Ls;
    return pad(h) + Lh + ' ' + pad(m) + Lm + ' ' + pad(s) + Ls;
  }

  function refresh() {
    var now = Date.now() / 1000;
    var nodes = document.querySelectorAll(SEL);

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var start = parseInt(el.getAttribute('data-start'), 10);
      var end = parseInt(el.getAttribute('data-end'), 10);

      if (isNaN(start) || isNaN(end)) {
        if (!el.hidden) el.hidden = true;
        continue;
      }

      var active = now >= start && now < end;
      if (el.hidden !== !active) el.hidden = !active;

      if (active) {
        var clock = el.querySelector('[data-fcy-timer]');
        if (clock) {
          var txt = format(end - now, el);
          if (clock.textContent !== txt) clock.textContent = txt;
        }
      }
    }
  }

  function loop() {
    refresh();
    window.setTimeout(loop, 1000);
  }

  function start() {
    loop();
    document.addEventListener('visibilitychange', refresh);
    window.addEventListener('focus', refresh);
    window.addEventListener('pageshow', refresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
